<h5 class="title-h5 text-center mb-8">{{ "public_register_title" | translate }}</h5>
<form [formGroup]="registerForm" (ngSubmit)="register()">
    <input type="text" appAutofocus pInputText formControlName="email" class="w-full mt-4" placeholder="{{ 'public_register_email' | translate }}" />
    @if (emailControl.invalid && displayValidationMessages) {
        <div class="flex flex-col field p-fluid mt-3">
            @if (emailControl.errors?.["required"]) {
                <p-message class="mb-1" severity="error">{{ "standard_email_required" | translate }}</p-message>
            } @else if (emailControl.errors?.["email"]) {
                <p-message class="mb-1" severity="error">{{ "standard_email_validation_error" | translate }}</p-message>
            }
        </div>
    }
    <div class="mt-6">
        <button pButton type="submit" class="body-button w-full p-button-blue-logo">
            {{ "public_register_button" | translate }}
        </button>
    </div>
</form>
<div class="mt-16 body-small text-center text-lig">
    {{ "public_register_already_customer" | translate }}
    <a routerLink="/login" class="text-blue-logo hover:underline">{{ "public_register_login" | translate }}</a>
</div>
